import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import type { FlexPropsInterface } from './types/flex.types';

/**
 * A component implementation of standard CSS Flexbox.
 *
 * @deprecated since v10.0 and we suggest you transition to using the `Box` component instead.
 *  This will be removed in the future.
 *
 * @related ['Grid']
 */

export const Flex = forwardRef<HTMLDivElement, FlexPropsInterface>(
  (props: FlexPropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;

    const styles = css(cssProp);

    const Component = asChild ? Slot : 'div';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Flex"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

Flex.displayName = 'Flex';
